import { useMemo } from 'react';

import { getABNVariant } from '~/src/helpers/abn-tests';

export const usePassportUpdate = () => {
    return useMemo(() => getABNVariant('use_passport_update') === 'on_use_passport_update', []);
};
